import { render, staticRenderFns } from "./submit-success-dialog.vue?vue&type=template&id=f5abd90e&scoped=true&"
import script from "./submit-success-dialog.vue?vue&type=script&lang=js&"
export * from "./submit-success-dialog.vue?vue&type=script&lang=js&"
import style0 from "./submit-success-dialog.vue?vue&type=style&index=0&id=f5abd90e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5abd90e",
  null
  
)

export default component.exports